<section class="demo-hero section__bg-gradient-parent">
  <div class="demo-hero__overlay" aria-hidden="true"></div>
  <div class="demo-hero__background" aria-hidden="true">
    <a
      class="demo-hero__canvas-frame"
      [href]="`${appUrl}/view/scenes/6a8dad6f2b6809db3522748b`"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Open the Old man scene in the 3D editor"
    >
      <img
        class="demo-hero__bg-image"
        fill
        priority
        ngSrc="/assets/demo/old-man-3D.jpg"
        alt="demo-hero background"
      />
    </a>
  </div>

  <div class="demo-hero__inner container">
    <app-button
      variant="secondary"
      [href]="`${appUrl}/view/scenes/6a8dad6f2b6809db3522748b`"
      ariaLabel="Open the Old man scene in the 3D editor"
    >
      Click to enter the scene
    </app-button>
  </div>
</section>
